const COLORS = [
  '#DA1D5D', // Raspberry
  '#9C27B0', // Purple
  '#3F51B5', // Indigo
  '#2196F3', // Blue
  '#00BCD4', // Cyan
  '#DDA600', // Amber
  '#F44336', // Red
  '#9E9E9E', // Grey
  '#607D8B', // Blue Grey
  '#009688', // Teal
  '#4CAF50', // Green
];

const countries = ['US', 'SK', 'PL', 'CZ', 'ES', 'IT', 'PK'];

export function getRandomColor(): string {
  return COLORS[Math.floor(Math.random() * COLORS.length)];
}

export function getRandomCountry(): string {
  return countries[Math.floor(Math.random() * countries.length)];
}

function hashStringToIndex(str: string, arrayLength: number): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) % arrayLength;
  }
  return hash;
}

export function getConsistentColor(str: string): string {
  return COLORS[hashStringToIndex(str, COLORS.length)];
}
